/**
 * Central AdSense slot registry — ported from `REACTJS/src/config/adSlots.js`.
 * Keep this in sync with the AdSense publisher dashboard. Spread an entry into
 * `<AdsenseSlot {...AdSlots.dashboard}/>` so slot/format/layout fields flow
 * through together.
 */
export interface AdSlot {
  /** Numeric slot ID from the AdSense publisher dashboard. */
  slot: string;
  /** `auto`, `fluid`, `rectangle`, etc. */
  format: 'auto' | 'fluid' | 'rectangle';
  /** Required for `fluid` in-article ads. */
  layout?: 'in-article';
  /** Required for `fluid` in-feed ads. */
  layoutKey?: string;
}

export const AdSlots = {
  /** In-article fluid — long-form text bodies (blog detail, news article, terms). */
  inArticle: { slot: '9621406007', format: 'fluid', layout: 'in-article' },
  /** In-feed fluid — between list cards (dashboard timeline every-Nth, blog list, etc.). */
  inFeed: {
    slot: '4435585985',
    format: 'fluid',
    layoutKey: '-f9+5v+4m-d8+7b',
  },
  /** Generic auto display — after-list banners, sidebar bottoms. */
  display: { slot: '9880157507', format: 'auto' },
  /** Dashboard timeline top banner. */
  dashboard: { slot: '1858458872', format: 'auto' },
  /** Profile center panel. */
  profile: { slot: '9856887918', format: 'auto' },
  /** Blog detail sidebar (Related Blogs). */
  blogSidebar: { slot: '4917446060', format: 'auto' },
  /** Live TV home (between Categories and Trending). */
  liveTvHome: { slot: '9681108575', format: 'auto' },
} as const satisfies Record<string, AdSlot>;
